export default {
  "article.title": "创作者学院",
  "article.desc": "学习短视频创作技巧，了解行业动态，提升你的创作能力",
  "article.readMore": "阅读全文",
  "article.publishedAt": "发布时间",
  "article.author": "作者",
  "article.related": "相关文章",
  "article.noArticles": "暂无文章",
  "article.backToList": "返回文章列表",
  "article.readCount": "次阅读",
  "article.tags": "标签",
};